// extracted by mini-css-extract-plugin
export var cardIcon = "_78-5";
export var checkboxCard = "_78-0";
export var checkboxCardSelected = "_78-4";
export var disabled = "_78-2";
export var interactive = "_78-1";
export var outerBorder = "_78-3";
export var spacerMedium = "_78-8";
export var spacerSmall = "_78-7";
export var spacerXsmall = "_78-6";